import "../../../../assets/presentation/components/controls/text-input/text-input-layout-BhhZuOC6.css";
/* empty css                  */
import classNames from "classnames";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/controls/text-input/text-input-layout.tsx
var TextInputLayout = ({ children, className, hasError, isDisabled, testId }) => {
	return /* @__PURE__ */ jsx("div", {
		className: classNames("text-input-layout", className, {
			"has-error": hasError,
			"disabled": isDisabled
		}),
		"data-testid": testId,
		children
	});
};
//#endregion
export { TextInputLayout };

//# sourceMappingURL=text-input-layout2.js.map